import { jsx } from "react/jsx-runtime";
import AntRadio from "antd/es/radio";
import classnames from "../../utils/classnames.js";
import './Radio.css';/* empty css           */
const Radio = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsx(AntRadio, { className: classnames("perxis-auto-radio", className), ...props, children });
};
const Group = ({ className, children, layout, options, ...props }) => {
  return /* @__PURE__ */ jsx(
    AntRadio.Group,
    {
      className: classnames(
        [
          "perxis-auto-radio-group",
          {
            "perxis-auto-radio-group--vertical": layout === "vertical",
            "perxis-auto-radio-group--horizontal": layout === "horizontal",
            "perxis-auto-radio-group--flex": layout === "flex"
          }
        ],
        className
      ),
      ...props,
      children: children || (options == null ? void 0 : options.map((option) => {
        var _a;
        return /* @__PURE__ */ jsx(
          Radio,
          {
            ...typeof option === "object" ? option : null,
            children: typeof option === "object" ? option.label : option
          },
          (_a = typeof option === "object" ? option.value : option) == null ? void 0 : _a.toString()
        );
      }))
    }
  );
};
Radio.Group = Group;
export {
  Radio as default
};
//# sourceMappingURL=Radio.js.map
